import { get, post } from "./_base";

const getById = (id) => {
  return get("/layout/" + id);
};
const getGroupedLayoutsByUser = () => {
  return get("/groupedLayoutsByUser");
};
const getLastPublicLayouts = (search) => {
  return get(`/lastPublicLayouts`);
};
const getPublicLayouts = (search) => {
  return get(`/publicLayouts/${search}`);
};
const createLayout = (data) => {
  return post("/createLayout", data);
};
const updateLayout = (data) => {
  return post("/updateLayout", data);
};
const deleteLayout = (data) => {
  return post("/deleteLayout", data);
};
const changeLayoutGroup = (data) => {
  return post("/changeLayoutGroup", data);
};
const captureLayout = (data) => {
  return post("/captureLayout", data);
};

export {
  getById,
  getGroupedLayoutsByUser,
  getLastPublicLayouts,
  getPublicLayouts,
  updateLayout,
  createLayout,
  deleteLayout,
  changeLayoutGroup,
  captureLayout,
};
